import { render } from "./Convenant.vue?vue&type=template&id=44eac29c"
import script from "./Convenant.vue?vue&type=script&lang=js"
export * from "./Convenant.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/public_html/wp-content/plugins/woo-portal-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__